class WymsHeroV2 extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    this.buttons = Array.from(this.querySelectorAll('[data-hero-dot]'));
    this.total = this.slides.length;
    this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.index < 0) this.index = 0;

    if (this.total < 2) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const next = Number(button.dataset.heroDot);
        if (Number.isNaN(next)) return;
        this.goTo(next);
      });
    });

    this._onKeyDown = (event) => {
      if (event.key === 'ArrowRight') this.goTo(this.index + 1);
      if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
    };
    this.addEventListener('keydown', this._onKeyDown);
    this._bindSwipe();
    this._bindAutoplay();
  }

  disconnectedCallback() {
    this._stopAutoplay();
    document.removeEventListener('visibilitychange', this._onVisibility);
    this.removeEventListener('keydown', this._onKeyDown);
  }

  goTo(nextIndex) {
    const next = (nextIndex + this.total) % this.total;
    if (next === this.index) return;

    this.slides.forEach((slide, i) => {
      const active = i === next;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.buttons.forEach((button) => {
      const active = Number(button.dataset.heroDot) === next;
      button.classList.toggle('is-active', active);
      if (active) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });

    this.index = next;
    this._startAutoplay();
  }

  _bindAutoplay() {
    this._delay = 6000;
    this.style.setProperty('--hero-autoplay', `${this._delay}ms`);
    this._paused = false;

    this._onVisibility = () => {
      if (document.hidden) this._pauseAutoplay();
      else this._resumeAutoplay();
    };
    document.addEventListener('visibilitychange', this._onVisibility);

    this._startAutoplay();
  }

  _pauseAutoplay() {
    this._paused = true;
    this._stopAutoplay();
    this.classList.add('is-paused');
  }

  _resumeAutoplay() {
    this._paused = false;
    this.classList.remove('is-paused');
    this._startAutoplay();
  }

  _startAutoplay() {
    this._stopAutoplay();
    if (this._paused || this.total < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this._restartProgress();
    this._timer = window.setTimeout(() => {
      this.goTo(this.index + 1);
    }, this._delay);
  }

  _stopAutoplay() {
    if (!this._timer) return;
    window.clearTimeout(this._timer);
    this._timer = null;
  }

  _restartProgress() {
    this.querySelectorAll('.wyms-hero-v2__bullet.is-active .wyms-hero-v2__bullet-fill').forEach((fill) => {
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = '';
    });
  }

  _bindSwipe() {
    let startX = 0;
    let tracking = false;

    this.addEventListener('touchstart', (event) => {
      if (!event.touches[0]) return;
      tracking = true;
      startX = event.touches[0].clientX;
    }, { passive: true });

    this.addEventListener('touchend', (event) => {
      if (!tracking || !event.changedTouches[0]) return;
      tracking = false;
      const delta = event.changedTouches[0].clientX - startX;
      if (Math.abs(delta) < 40) return;
      this.goTo(delta < 0 ? this.index + 1 : this.index - 1);
    }, { passive: true });
  }
}

if (!customElements.get('wyms-hero-v2')) {
  customElements.define('wyms-hero-v2', WymsHeroV2);
}
